module.exports = __webpack_public_path__ + "static/media/fruits_39.08dfa237.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/fruits/fruits_39.csv
// module id = 705
// module chunks = 0